import { accessRole } from "../../../../helpers/access_role"
import ErrorAccess from '../../../../components/Error/Content/Access'
import React, { useEffect } from "react"
import { Redirect } from "react-router-dom"

import Index from './Index/View'
import List from './List/View'
import ListPegawai from './ListPegawai/View'
import Create from './Create/View'
import CreateAdmin from './CreateAdmin/View'
import Detail from './Detail/View'
// import Update from './Update/View'
import Approve from './Approve/View'
import Update from './Update/View'
import UpdateAdmin from './UpdateAdmin/View'

const RouteView = (props) => {
    const { params } = props    
	const queryParams = new URLSearchParams(props.location.search);
    const _id = queryParams.get('id')
    const _uuid = queryParams.get('uuid')
    const _date = queryParams.get('date')
    const _create = queryParams.get('create')
    const _list = queryParams.get('list')
    const _detail = queryParams.get('detail')
    const _update = queryParams.get('update')
    const _delete = queryParams.get('delete')
    const _approve = queryParams.get('approve')
    const _print = queryParams.get('print')

    if (_create != null) {
        if (accessRole('approve')) { // if admin
            return accessRole('create') ? <CreateAdmin date={_date} /> : <ErrorAccess />
        }
    	return accessRole('create') ? <Create date={_date} /> : <ErrorAccess />
    } else if (_detail != null) {
    	return accessRole('read') ? <Detail uuid={_uuid} /> : <ErrorAccess />
    } else if (_update != null) {
        if (accessRole('approve')) { // if admin
            return accessRole('update') ? <UpdateAdmin uuid={_uuid} /> : <ErrorAccess />
        }
    	return accessRole('update') ? <Update uuid={_uuid} /> : <ErrorAccess />
    } else if (_list != null) {
    	return accessRole('read') ? <List uuid={_uuid} /> : <ErrorAccess />
    } else if (_delete != null) {
    	return null
    } else if (_approve != null) {
    	return accessRole('approve') ? <Approve uuid={_uuid} /> : <ErrorAccess />
    } else if (_print != null) {
    	return null
    }

    // Jika Admin
    if (accessRole('approve')) {
        return accessRole('read') ? <Index /> : <ErrorAccess />
    } else {
        return accessRole('read') ? <ListPegawai uuid={_uuid} /> : <ErrorAccess />
    }


}

export default RouteView